import _ from 'lodash'

export const getRandomIndexFromArray = array => {
  if (!array) {
    return null
  }
  const length = array.length
  if (length === 0) {
    return null
  }
  return _.random(length - 1)
}

export const getRandomValueFromArray = array => {
  const randomIndex = getRandomIndexFromArray(array)
  if (randomIndex === null || randomIndex === undefined) {
    return null
  }
  return array[randomIndex]
}
